export const appFontFamilies = ['Avenir', 'AvenirNext'];
